
export const PlanOverviewInput = [
  {
    label: "Plan Name",
    type: "text",
    id: "workoutname",
    valueKey: "plan_name",
  },
  {
    label: "Duration",
    type: "text",
    id: "Duration",
    valueKey: "duration",
  },
  {
    label: "Time/Day",
    type: "select",
    id: "Time/Day",
    options: ["One", "Two", "Three"],
    valueKey: "timeOfDay",
  },
  {
    label: "Category",
    type: "select",
    id: "Category",
    options: ["Strength", "Cardio", "Flexibility"],
    valueKey: "training_type",
  },
  {
    label: "Days/Week",
    type: "select",
    id: "Days/Week",
    options: ["One", "Two", "Three"],
    valueKey: "daysOfWeek",
  },
  {
    label: "Level",
    type: "select",
    id: "Level",
    options: ["Beginner", "Intermediate", "Advanced"],
    valueKey: "level",
  },
  {
    label: "Plan Description",
    type: "textarea",
    id: "PlanDescription",
    valueKey: "description",
  },
  {
    label: "Plan Keywords",
    type: "textarea",
    id: "PlanKeywords",
    valueKey: "keywords",
  },
 
];
